<app-document-popup-project #document></app-document-popup-project>
<app-pay-popup-project #pay></app-pay-popup-project>
<app-group-popup-project #group></app-group-popup-project>
<app-summary-information #summary></app-summary-information>
<app-close-popup-project #close></app-close-popup-project>
<app-delete-popup-project #delete></app-delete-popup-project>


<section>

  <div>
    <h4 class="text-white h2 mt-3 px-5 pt-3">Listado de proyectos</h4>
  </div>

  
    <div class="componente-importantes-from mt-2 mb-5">    
      <form [formGroup]="searchForm"  class="row mx-5 ">
      
        <div class="col-md-1 my-2"></div>

        <div class="col-md-2 my-2">
            <ng-multiselect-dropdown id="stado" formControlName="stado" 
            [placeholder]="'Estados'"
            [settings]="dropdownSettings"
            [data]="filterProjectInfoDto.listStado"
            (onSelect)="onItemSelect($event)">
          </ng-multiselect-dropdown>
        </div>

        <div class="col-md-2 my-2">
          <select class="form-select custom-outline-input" aria-label="Default select example" (change)="actionSelectClient()" id="type" formControlName="type">
            <option value="0">Seleccionar tipo</option>
            <option *ngFor="let datoType of filterProjectInfoDto.listType" [ngValue]="datoType">
              {{datoType.name}}
            </option>
          </select>
        </div>

        <div class="col-md-2 my-2">
          <select class="form-select custom-outline-input" aria-label="Default select example" (change)="actionSelectClient()" id="client" formControlName="client">
            <option value="0">Seleccionar cliente</option>
            <option *ngFor="let datoClient of filterProjectInfoDto.listClient" [ngValue]="datoClient">
              {{datoClient.name}}
            </option>
          </select>
        </div>

        <div class="col-md-2 my-2">
          <select class="form-select custom-outline-input" aria-label="Default select example" id="frete" formControlName="frete">
            <option value="0">Seleccionar frente</option>
           <option *ngFor="let datoFrente of filterProjectInfoFrenteDto" [ngValue]="datoFrente">
              {{datoFrente.name}}
            </option>
          </select>
        </div>

        <div class="col-md-2 my-2">
          <ng-multiselect-dropdown id="item" formControlName="item" 
          [placeholder]="'item'"
          [settings]="dropdownSettings"
          [data]="filterProjectInfoDto.listItem"
          (onSelect)="onItemSelect($event)">
        </ng-multiselect-dropdown>
      </div>

        <div class="col-md-1 my-2">
        
          <div class="d-grid gap-2">
              <button type="button" class="btn btn-outline-light" (click)="btnSearch()">Filtrar</button>
            </div>
        </div>
      </form>
    </div>

    <div class="container-fluid px-5">
      <div class="backgroundTable">
  
      <div class="row">
          <div class="col-6 filterDatatable">
            <div class="col-md-6 text-left">
              <select
                name="" class="form-control-table custom-select"  (change)="actionSelectFiter($event)" [(ngModel)]="opcionSeleccionado" >
                <option value="todo">Todos los estados</option>
                <option value="badge-success">Éxito</option>
                <option value="badge-danger">Peligro</option>
                <option value="badge-warning">Advertencia</option>
                <option value="badge-info">Información</option>
                <option value="badge-default">Sin registro de pago</option>
              </select>
            </div>
          </div> 
        </div>
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">
          
          <ng-container *ngIf="listViewProjectDto.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="listViewProjectDto.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Nombre</th>
              <th class="text-white text-center">Cliente</th>
              <th class="text-white text-center">Responsable</th>
              <th class="text-white text-center">Pagos</th>
              <th class="text-white text-center">Desviacion</th>
              <th class="text-white text-center">Inicio</th>
              <th class="text-white text-center">Fin</th>
              <th class="text-white text-center">Opciones</th>
          </thead>

          <tbody>
            <tr *ngFor="let item of listViewProjectDto">

              <ng-container *ngIf="permisoDetailProject == true">
                <td class="text-center pointer text-init" (click)="projectDetails(item.id)">{{item.projectAlias}}</td>
              </ng-container>

              <ng-container *ngIf="permisoDetailProject == false">
                <td class="text-center" >{{item.projectAlias}}</td>
              </ng-container>

              <td class="text-center">

                <div class="row">
                  
                  <ng-container *ngIf="permisoInfo == true">
                    <div class="col-auto"><span class=" "  (click)="summary.open(item.id)" > <i class="fa-solid fa-eye fa-xl pointer"></i></span></div>
                  </ng-container>

                  <div class="col text-center"> <span >{{item.nameBusiness}}</span></div>
                </div>
            
              </td>
              <td class="text-center">{{item.userName}}</td>
              <td class="text-center">
                <div class="d-flex justify-content-center bd-highlight mb-2">
                  <div class="p-2 bd-highlight">
                    <span [ngClass]="item.userAttachments != '' ? 'badge-success' : 'badge-danger'"  (click)="document.open(item)" class=" " > <i class=" mt-2 fa-regular fa-file fa-xl pointer"></i></span>

                  </div>
                  <div class="p-2 bd-highlight">
                    <span [ngClass]="item.payment.colorStatus" (click)="pay.open(item.payment, 'pay')" class=" " ><i class="mt-2 fa-solid fa-dollar-sign fa-xl pointer"></i></span>
                  </div>
                </div>
              </td>
              <td >
                <div class="p-2 bd-highlight d-flex flex-column">
                    <span *ngIf="item.lastProgress >= 0"
                        class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">Actual {{item.lastProgress}} <i class="fa-solid fa-arrow-trend-up"></i> </span>
                      <span *ngIf="item.lastProgress < 0"
                        class="badge rounded-pill text-bg-warning p-2 " style="font-size: 12px;">Actual {{item.lastProgress}} <i class="fa-solid fa-arrow-trend-down"></i></span>
                      
                    <span *ngIf="item.previousProgress >= 0"
                        class="badge rounded-pill text-bg-success p-2 mt-2 " style="font-size: 12px;">Antes {{item.previousProgress}} <i class="fa-solid fa-arrow-trend-up"></i> </span>
                      <span *ngIf="item.previousProgress < 0"
                        class="badge rounded-pill text-bg-warning p-2  mt-2" style="font-size: 12px;">Antes {{item.previousProgress}} <i class="fa-solid fa-arrow-trend-down"></i></span>
                
                
                </div>

            </td>
              <td class="text-center">{{item.startDate}}</td>

              <td >
                <div class="p-2 bd-highlight d-flex flex-column">
                  <span *ngIf="item.colorDate === 'green'"
                      class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.endDate}}</span>
                      <span *ngIf="item.colorDate === 'red'"
                      class="badge rounded-pill text-bg-danger p-2 " style="font-size: 12px;">{{item.endDate}}</span>
              </div>
            </td>
             
              
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl pointer" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <ng-container *ngIf="permisoOptionAdmin == true">
                      <button (click)="group.open(item.id)" ngbDropdownItem>Vincular al grupo</button>
                    </ng-container>

                    <ng-container *ngIf="permisoOptionAdminTeam == true">
                      <a ngbDropdownItem [routerLink]="['./../edit',item.id,'3']" >Administrar Equipo</a>
                    </ng-container>

                    <ng-container *ngIf="permisoContractAnnex == true">
                      <a [routerLink]="['./../edit',item.id,'4']" ngbDropdownItem>Anexos de Contratos</a>
                    </ng-container>

                    <ng-container *ngIf="permisoPayment == true">
                      <ng-container *ngIf="item.payConfigEnable == 1">
                        <a [routerLink]="['/pdg/project/pay/list/',item.id,item.projectAlias]" ngbDropdownItem>Pagos</a>
                      </ng-container>
                      <ng-container *ngIf="item.payConfigEnable == 0">
                        <a [routerLink]="['/pdg/project/pay/create/',item.id,0,item.projectAlias]" ngbDropdownItem>Pagos</a>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="permisoOptionAdmin == true">
                      <a [routerLink]="['./../edit',item.id,'1']" ngbDropdownItem>Editar</a>
                    </ng-container>

                    <ng-container *ngIf="permisoCostEffectiveness == true">
                      <a [routerLink]="['/pdg/project','cost-effectiveness',item.id,item.projectAlias]" ngbDropdownItem>Rentabilidad</a>
                    </ng-container>

                    <ng-container *ngIf="permisoOptionAdmin == true">
                      <button (click)="close.open(item.id)" ngbDropdownItem *ngIf="item.close==0">Cerrar proyecto</button>
                      <button (click)="projectActivated(item.id)" ngbDropdownItem *ngIf="item.pause!=0">Activar</button>
                      <button (click)="projectPaused(item.id)" ngbDropdownItem *ngIf="item.pause==0">Pausar</button>
                      <button (click)="delete.open(item.id)" ngbDropdownItem>Eliminar</button>
                      <button (click)="openProject(item.id)" ngbDropdownItem *ngIf="item.close==1">Abrir proyecto</button>
                    </ng-container>

                  </div>
                </div>
              </td>
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
  </section>
